<!--
  A failure's request (what failed, its status, the time and the request
  ID) behind a collapsed "Details" disclosure, with Copy details for
  sending it to support.
-->
<script lang="ts">
  import { formatDetails, type Failure } from '../api/failure';

  let { failure }: { failure: Failure } = $props();

  const text = $derived(formatDetails(failure));
  let copied: 'no' | 'yes' | 'failed' = $state('no');
  // A new failure (each retry's) has not been copied.
  $effect.pre(() => {
    void failure;
    copied = 'no';
  });

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      copied = 'yes';
    } catch {
      copied = 'failed';
    }
  }
</script>

<details class="failure-details">
  <summary>Details</summary>
  <pre>{text}</pre>
  <div class="failure-copy">
    <button class="btn small" type="button" onclick={copy}>Copy details</button>
    <span class="muted" role="status">{copied === 'yes' ? 'Copied.' : copied === 'failed' ? "Couldn't copy; select the text above instead." : ''}</span>
  </div>
</details>

<style>
  .failure-details {
    text-align: left;
    font-size: 13px;
    color: var(--muted);
    max-width: 100%;
  }
  .failure-details summary {
    cursor: pointer;
    width: max-content;
  }
  pre {
    margin: 8px 0;
    padding: 10px 12px;
    background: var(--code);
    color: var(--fg);
    border-radius: 6px;
    font: 12px/1.5 ui-monospace, SFMono-Regular, Consolas, monospace;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    user-select: all;
  }
  .failure-copy {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
  }
</style>
